<template>
    <section :class="this.$route.query.v">
        <div class="limiter" align="center" id="emailHolder" v-if="changeLogin == 'email'">
            <div class="container-login100">
                <div class="wrap-login100 p-l-50 p-r-50 p-t-77 p-b-30">
                    <div class="login100-form validate-form">
                        <div align="center" class="containerLogo w-100">
                            <img class="img-fluid" :src="logo" width="374">
                        </div>
                        <span class="login100-form-title p-b-55">
                            Fichaje Web<br><small class="subString">Consulta, Edita y Actualiza tu estado desde aqui</small>
                        </span>


                        <div class="wrap-input100 validate-input m-b-16">
                            <input class="input100" type="text" placeholder="Usuario" v-model="user"  v-validate="'required'">
                            <span class="focus-input100"></span>
                            <span class="symbol-input100">
                                <span class="lnr lnr-envelope"></span>
                            </span>
                        </div>

                        <div class="wrap-input100 validate-input m-b-16" data-validate="Password is required">
                            <input class="input100" type="password" placeholder="Contraseña" v-model="password"  v-validate="'required'" v-on:keyup.enter="loginMail">
                            <span class="focus-input100"></span>
                            <span class="symbol-input100">
                                <span class="lnr lnr-lock"></span>
                            </span>
                        </div>

                        <div class="container-login100-form-btn p-t-25" @click="loginMail()">
                            <button class="login100-form-btn">
                                Actualizar mi Estado
                            </button>
                        </div>
                        <input type="hidden" id="idUserHold">
                        <hr>


                        <a class="btn-face m-b-10 pinBtnHolder" @click="changeLogin = 'pin'">
                            Acceso Mediante PIN
                        </a>
                        <small class="copyFooter"><span class="Year">2020</span> © {{ copy }} |&nbsp;ver 1.0.1a </small>
                    </div>
                </div>
            </div>
        </div>

        <div align="center" class="limiter animated fadeIn" id="PINHolder" v-if="changeLogin == 'pin'">
            <div class="container-login100">
                <div class="wrap-login100 p-l-50 p-r-50 p-t-77 p-b-30">
                    <div class="login100-form validate-form">
                        <div align="center" class="containerLogo w-100">
                            <img class="img-fluid" :src="logo" width="374">
                            </img>
                        </div>
                        <span class="login100-form-title p-b-55">
                            Fichaje Web
                            <br>
                                <small class="subString">
                                    Consulta, Edita y Actualiza tu estado desde aqui
                                </small>
                            </br>
                        </span>
                        <div class="wrap-input100 validate-input m-b-16">
                            <input class="input100" id="inputPIN" v-model="pin" placeholder="Código PIN" type="text">
                                <span class="focus-input100">
                                </span>
                                <span class="symbol-input100">
                                    <span class="lnr lnr-envelope">
                                    </span>
                                </span>
                            </input>
                          <button class="reiniciar-pin" @click="reiniciarPIN()" style="margin-right: auto;display: flex;margin-top: 3px;position: absolute;font-size: 14px;bottom: -27px;color: #D33F8D;">Reiniciar PIN</button>
                        </div>
                        <div align="center" class="dialerHolder" style="margin-top:25px">
                            <div class="row">
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn" @click="setValuePIN(0)">
                                        0
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn dialerBtnStripe" @click="setValuePIN(1)">
                                        1
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn" @click="setValuePIN(2)">
                                        2
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn dialerBtnStripe" @click="setValuePIN(3)">
                                        3
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn" @click="setValuePIN(4)">
                                        4
                                    </button>
                                </div>
                            </div>
                            <div class="row rowMargin">
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn dialerBtnStripe" @click="setValuePIN(5)">
                                        5
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn" @click="setValuePIN(6)">
                                        6
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn dialerBtnStripe" @click="setValuePIN(7)">
                                        7
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn" @click="setValuePIN(8)">
                                        8
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <button class="login100-form-btn dialerBtn dialerBtnStripe" @click="setValuePIN(9)">
                                        9
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="container-login100-form-btn p-t-25" @click="loginPIN()">
                            <button class="login100-form-btn">
                                Consultar mi Estado
                            </button>
                        </div>
                        <hr>

                        <a class="btn-face m-b-10 pinBtnHolder" @click="changeLogin = 'email'">
                            Acceso Mediante Cuenta
                        </a>
                        <small class="copyFooter">
                            <span class="Year">
                                2019
                            </span>
                            © {{ copy }} | ver 1.0.1a
                        </small>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import Api from '../api.js'

export default {
    name: 'HelloWorld',
    data () {
        return {
            user: '',
            password: '',
            changeLogin: 'email',
            pin: '',
            logo: '',
            copy: '',
        }
    },
    methods: {
        loginMail() {
            var instance = this
            this.$validator.validate().then(result => {
                if (!result) {
                    this.$swal.fire('Campos en blanco', '', 'error')
                } else {
                    Api.apiCall(apiUrl + '/auth/operator/login', {
                        usr: this.user,
                        pass: this.password
                    })
                    .then(function (response) {
                        if (response.response == 'Credenciales Correctas') {
                            instance.$swal.fire('Credenciales Correctas', '', 'success')
                            instance.$store.dispatch('setUser', response.value)
                            instance.$router.push({path: '/app', query: { v: instance.$route.query.v }})
                          /*GUARDO EL COMPANY ID PARA LA HORA DEL LOGIN PIN*/
                          localStorage.setItem('companypin', response.value.company.sessionid);
                        } else {
                            instance.$swal.fire('Credenciales Incorrectas', '', 'error')
                        }
                    })
                }
            });
        },
        loginPIN() {
            var instance = this
            if (this.pin.length == 0) {
                this.$swal.fire('Campos en blanco', '', 'error')
                return false
            }
           if(localStorage.getItem('companypin') == null){
              instance.$swal.fire('Error', 'Necesitas acceder con usuario y contraseña la primera vez que uses la aplicación por motivos de Seguridad', 'error')
              return false
            }
            Api.apiCall(apiUrl + '/auth/operator/login-pin-new', {
                pin: this.pin,
                companypin: localStorage.getItem('companypin')
            })
            .then(function (response) {
                if (response.response == 'Credenciales Correctas') {
                    instance.$swal.fire('Credenciales Correctas', '', 'success')
                    instance.$store.dispatch('setUser', response.value)
                    instance.$router.push({path: '/app', query: { v: instance.$route.query.v }})
                } else {
                    instance.$swal.fire('Credenciales Incorrectas. ', 'Recuerda! Si estás introduciendo un PIN de otra empresa, deberás acceder previamente mediante usuario y contraseña', 'error')
                }
            })
        },
        setValuePIN(value) {
            this.pin += value
        },
      reiniciarPIN(){
        this.pin = ''
      }
    },
    mounted() {
        if(this.$route.query.v == 'meetcontrol') {
            this.logo = "/static/images/meetcontrol.png"
            this.copy = "MeetControl"
        } else {
            this.logo = "/static/images/logoOriginal.png"
            this.copy = ""
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginComponent.vue